import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import Button from '../../../../../components/UI/Button';

import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "config/constants";

const TITLE = "Change Password";
const DONE_TEXT = "SAVE";
const CLOSE_TEXT = "CLOSE"
const NEW_PASSWORD = "New Password";
const ERROR_TEXT = "Please enter valid password. It should be minimum of 6 alpha numeric characters.";

/**
 * An component used to show the dialog to change the user password.
 */
export default class SetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: ''
        }
    }

    isValidPassword() {
        return this.state.password.trim().length >= 6;
    }

    render() {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{NEW_PASSWORD} &nbsp; &nbsp;</p>
                    <input
                        type='password'
                        value={this.state.password}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite }, ...{ border: this.isValidPassword() ? "1px solid #444445" : "1px solid #ff0000" } }}
                        onChange={e => {
                            this.setState({
                                password: e.target.value
                            });
                        }}
                    />
                </div>
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={this.save}>
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.closeButton}
                        type="primary"
                        onClick={this.props.close}>
                        {CLOSE_TEXT}
                    </Button>
                </div>
            </ModalOverlay>
        )
    }

    save = () => {
        if (this.isValidPassword()) {
            let toastId = toast("Updating password...")
            axios.post(
                `${API_URL}/user/change_password`,
                {
                    email: this.props.email,
                    new_password: this.state.password
                },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("access_token")
                    }
                }).then(() => {
                    toast.dismiss(toastId);
                    toast("Updated successfully", { autoClose: 1000 });
                    this.props.close();
                }).catch((e) => {
                    toast.dismiss(toastId);
                    let message = e.message;
                    if (e.response && e.response.data && e.response.data.message) {
                        message = e.response.data.message
                    }
                    toast(message, { autoClose: 2000 });
                })
        } else {
            toast(ERROR_TEXT, { autoClose: 2000 });
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "160px",
        fontSize: "20px"
    },
    closeButton: {
        width: "160px",
        fontSize: "20px",
        marginLeft: "20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 70
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
}